// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2V8Sg","fileBtn":"File_fileBtn__zMxiQ","closeBtn":"File_closeBtn__21ehi","fileSelected":"File_fileSelected__390pG","disabled":"File_disabled__-7uTA"};